module.exports = __webpack_public_path__ + "img/Frage4_1024x768.4a84925b.jpg";